import * as React from 'react';

import {
  Routes,
  Route,
  useLocation,
  Navigate,
  unstable_HistoryRouter as HistoryRouter
} from 'react-router-dom';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loader from './common/Loader';
import { history } from './app/history';
import { getLoggedInUser } from 'utilities/helpers';
import socketService from './pages/SocketFiles/componenets/socketService.js';
import { connectSocket } from './pages/socket.js';
// Import Google Analytics utilities
import { initGA, pageview } from './utilities/gtag';
// Component imports
import Login from './pages/login';
import WelcomeLogin from './pages/LoginWelcomePage';
import WelcomePage from './pages/welcomePage';
import Register from './pages/Registration';
import ListView from './pages/ListView';
import HelpCenter from './pages/HelpCenter';
import ManageSettings from './pages/ManageSettings';
import ManageProfile from './pages/ManageProfile';
import ProfileView from './pages/ProfileView';
import SearchPage from './pages/Search';
import SearchResult from './pages/SearchResult';
import FeebBack from './pages/Feedback';
import EditProfile from './pages/EditProfile';
import EditFamilydetails from './pages/EditFamilyDetails';
import EditEducationdetails from './pages/EditEducationsDetails';
import EditHoroscopedetails from './pages/EditHoroscopeDetails';
import EditContactdetails from './pages/EditContact';
import EditDesiredPartnerDetails from './pages/EditDesiredPartnerDetails';
// import MemberShipDetails from './pages/MemberShip';
import MemberShipDetails from './pages/MemberShip_OffersPage';
// import MemberShipList from './pages/WelcomeMemberShipDetails';
import MemberShipList from './pages/WelcomeMemberShipDetails_OffersPage';
// import FooterMemberShipList from './pages/FooterMemberShipDetails';
import FooterMemberShipList from './pages/FooterMemberShipDetails_OffersPage';
import PgateWay from './pages/paymentgateway';
import SuccessPage from './pages/paymentgateway/components/Success/Payment.js';
import FalsePage from './pages/paymentgateway/components/False';
import CookiePolicy from './pages/CookiePolicy/index';
import PrivacyPolicy from './pages/PrivacyPolicy/index';
import TermsConditions from './pages/TermsConditions/index';
import CancellationPolicy from './pages/CancellationPolicy/index';
import FAQs from './pages/FAQs';
import WelcomeFAQs from './pages/WelcomeFAQ';
// Socket Initializer Component

const SocketInitializer = () => {
  React.useEffect(() => {
    const { loggedIn, user_details } = getLoggedInUser();

    if (loggedIn && user_details) {
      const API_URL =
        process.env.REACT_APP_API_URL2 || 'https://api.samskrutimatrimony.com';

      socketService.initialize(API_URL);
      socketService.connect();

      return () => {
        socketService.disconnect();
      };
    }
  }, []);

  return null;
};

// Analytics Tracker Component

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes

    pageview(location.pathname + location.search);
  }, [location]);

  return null;
};

// Route Protection Components

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { loading } = useSelector((state) => state.login);
  const { loggedIn } = getLoggedInUser();

  if (loading) {
    return <Loader />;
  }

  if (!loggedIn) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

const AuthChecker = ({ children }) => {
  const location = useLocation();
  const { loggedIn } = getLoggedInUser();

  if (loggedIn) {
    const { user_details } = getLoggedInUser();
    connectSocket(user_details?.id);
    return <Navigate to="/dashboard" state={{ from: location }} />;
  }

  return children;
};

// Main App Component

function App() {
  const goTo = '/welcome';

  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    // Initialize Tawk.to chat if user is logged in
    if (localStorage.getItem('isLoggedIn') === 'true') {
      if (typeof window.loadTawkTo === 'function') {
        window.loadTawkTo();
      }
    }
  }, []);

  return (
    <HistoryRouter history={history}>
      <SocketInitializer />
      <AnalyticsTracker />
      <Routes>
        {/* Root redirect */}
        <Route path="/" element={<Navigate replace to={goTo} />} />
        {/* Public routes with auth checking */}
        <Route
          path="welcome"
          element={
            <AuthChecker>
              <WelcomePage />
            </AuthChecker>
          }
        />
        <Route
          path="login"
          element={
            <AuthChecker>
              <Login />
            </AuthChecker>
          }
        />
        <Route
          path="access"
          element={
            <AuthChecker>
              <WelcomeLogin />
            </AuthChecker>
          }
        />
        <Route
          path="register"
          element={
            <AuthChecker>
              <Register />
            </AuthChecker>
          }
        />
        {/* Public policy pages */}
        <Route path="cookie-policy" element={<CookiePolicy />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-and-conditions" element={<TermsConditions />} />
        <Route
          path="policy-on-cancellations"
          element={<CancellationPolicy />}
        />
        <Route path="welcome/faqs" element={<WelcomeFAQs />} />
        <Route path="membership" element={<FooterMemberShipList />} />
        {/* Protected routes */}
        <Route
          path="dashboard"
          element={
            <PrivateRoute>
              <ListView />
            </PrivateRoute>
          }
        />
        <Route
          path="helpcenter"
          element={
            <PrivateRoute>
              <HelpCenter />
            </PrivateRoute>
          }
        />
        <Route
          path="settings"
          element={
            <PrivateRoute>
              <ManageSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="manageProfile"
          element={
            <PrivateRoute>
              <ManageProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="profileview/:id"
          element={
            <PrivateRoute>
              <ProfileView />
            </PrivateRoute>
          }
        />
        <Route
          path="search"
          element={
            <PrivateRoute>
              <SearchPage />
            </PrivateRoute>
          }
        />
        <Route
          path="searchresult"
          element={
            <PrivateRoute>
              <SearchResult />
            </PrivateRoute>
          }
        />
        <Route
          path="feedback"
          element={
            <PrivateRoute>
              <FeebBack />
            </PrivateRoute>
          }
        />
        <Route
          path="faqs"
          element={
            <PrivateRoute>
              <FAQs />
            </PrivateRoute>
          }
        />
        {/* Profile editing routes */}
        <Route
          path="editprofile"
          element={
            <PrivateRoute>
              <EditProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="editfamily"
          element={
            <PrivateRoute>
              <EditFamilydetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editfamily/:id"
          element={
            <PrivateRoute>
              <EditFamilydetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editeducation"
          element={
            <PrivateRoute>
              <EditEducationdetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editeducation/:id"
          element={
            <PrivateRoute>
              <EditEducationdetails />
            </PrivateRoute>
          }
        />
        <Route
          path="edithoroscope"
          element={
            <PrivateRoute>
              <EditHoroscopedetails />
            </PrivateRoute>
          }
        />
        <Route
          path="edithoroscope/:id"
          element={
            <PrivateRoute>
              <EditHoroscopedetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editcontact"
          element={
            <PrivateRoute>
              <EditContactdetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editcontact/:id"
          element={
            <PrivateRoute>
              <EditContactdetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editpartner"
          element={
            <PrivateRoute>
              <EditDesiredPartnerDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="editpartner/:id"
          element={
            <PrivateRoute>
              <EditDesiredPartnerDetails />
            </PrivateRoute>
          }
        />
        {/* Membership and payment routes */}
        <Route
          path="membership_payment"
          element={
            <PrivateRoute>
              <MemberShipDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="membership_list"
          element={
            <PrivateRoute>
              <MemberShipList />
            </PrivateRoute>
          }
        />
        <Route
          path="gateway"
          element={
            <PrivateRoute>
              <PgateWay />
            </PrivateRoute>
          }
        />
        <Route
          path="success"
          element={
            <PrivateRoute>
              <SuccessPage />
            </PrivateRoute>
          }
        />
        <Route
          path="failure"
          element={
            <PrivateRoute>
              <FalsePage />
            </PrivateRoute>
          }
        />
      </Routes>
    </HistoryRouter>
  );
}

export default App;
